import type { PepGeneral } from '@/shared/schemas/pep'
import type { Fatca } from '../models/fatca-scheme'
import type { ApplicantIndividualDraft } from '../models/individual-schema'
import type { IEconomicInfo } from '../models/info-economic-schema'
import type { Kyc } from '../models/kyc-form'

export const INITIAL_APPLICANT_INDIVIDUAL: ApplicantIndividualDraft = {
  name: { first: '' },
  lastName: { first: '' },
  identificationCard: {
    type: '',
    dateDue: '',
    emission: { country: '' },
    number: ''
  },
  birthplace: {
    country: ''
  },
  birthdate: '',
  gender: '',
  civilStatus: '',
  profession: '',
  economicActivityRTU: '',
  email: '',
  residence: {
    address: '',
    zone: 0,
    country: ''
  },
  nationality: [],
  phone: [],
  ownAct: true
}

export const INITIAL_PEP_CLIENT: PepGeneral = {
  isPep: false,
  pep: [],
  hasRelativesPep: false,
  relativesPep: [],
  hasPartnersPep: false,
  partnersPep: [],
  isCPE: false
}

export const INITIAL_FATCA_INDIVDIUAL: Fatca = {
  bornUS: false,
  nationalityUS: false,
  isUsIncomeTaxpayer: false,
  isUSCitizenOrResident: false,
  hasUSAddress: false,
  sendOrReceiveFundsToUS: false,
  usSignatoriesOrResidents: false
}

export const INITIAL_ECONOMIC_INFO_INDIVIDUAL: IEconomicInfo = {
  businessRelationship: '',
  hasDependencyRelations: false,
  hasOwnBusinesses: false,
  hasOtherIncomes: false,
  dependecyRelations: [],
  ownBusinesses: [],
  otherIncomes: [],
  monthlyIncomes: [],
  monthlyExpenses: []
}

export const INITIAL_KYC_FORM_INDIVIDUAL: Kyc = {
  retainIVA: false,
  retainISR: false,
  transacctions: {
    investment: '',
    disinvestment: ''
  },
  operationsMonthly: {
    investment: '',
    disinvestment: ''
  },
  comments: '',
  referredBy: '',
  originResources: []
}
